import { Injectable } from '@angular/core';
import { ApiClientService } from './util/api.client.service';
import { CityDto } from '../../models/city.dto';
import { OfficeDto } from '../../models/office.dto';
import { SectionalItemOrganizationDto } from '../../models/sectionalItemOrganization.dto';

@Injectable({
  providedIn: 'root'
})
export class OfficeService {

  constructor(public http: ApiClientService) { }

  getAllOffice() {
    return this.http.get('/office');
  }

  getAllOperatorOffice() {
    return this.http.get('/secure/office');
  }

  getAllSectionalTypes() {
    return this.http.get('/sectional/sectionalType');
  }

  getOfficeSectionalTypes(officeId: any) {
    return this.http.get('/sectional/sectionalType?officeId=' + officeId);
  }

  getAllSecureSectionalTypes() {
    return this.http.get('/sectional/secure/sectionalType');
  }

  getSLCities(filterNotConfiguredOffice: any) {
    return this.http.get<CityDto[]>('/city/sl?filterNotConfiguredOffice=' + filterNotConfiguredOffice);
  }

  getOfficeByCityId(id: number) {
    return this.http.get<OfficeDto[]>(`/office/city/${id}`);
  }

  getSectionalItemsBySectionalType(sectionalTypeId: any) {
    return this.http.get(`/sectional/sectionalType/${sectionalTypeId}/sectionalItem`);
  }

  getStampBySectionalItem(sectionalItemId: any) {
    return this.http.get(`/sectional/sectionalItem/${sectionalItemId}/stampType`);
  }

  getStampBySectionalItemAndOrganization(sectionalItemId: any, organizaztionId: any) {
    return this.http.get(`/sectional/sectionalItem/${sectionalItemId}/organization/${organizaztionId}/stampType`);
  }

  getOrganizationBySectionalItem(sectionalItemId: any) {
    return this.http.get<SectionalItemOrganizationDto[]>(`/sectional/sectionalItem/${sectionalItemId}/organization`);
  }

  requestAppointment(model: any) {
    return this.http.post(`/appointment/create`, model);
  }

  requestCertificate(model: any) {
    return this.http.post(`/appointment/certificate/create`, model);
  }
}
